// 在 Vue 中创建一个工具方法或直接在组件中使用
export function congTypeFollow () {
	// 二级菜单选中跟随
	if ($(".congtype .item").length > 0) {
		var itemoptleft = $(".congtype .item.opt").offset().left - $(".congtype .left").offset().left
		$(".congtype .line").stop().animate({ left: itemoptleft + "px", width: $(".congtype .item.opt").width() + "px" }, 0);
		$(".congtype .item").hover(function () {
			var hoveritemleft = $(this).offset().left - $(".congtype .left").offset().left
			$(".congtype .line").stop().animate({ left: hoveritemleft + "px", width: $(this).width() + "px" }, 0);
		}, function () {
			$(".congtype .line").stop().animate({ left: itemoptleft + "px", width: $(".congtype .item.opt").width() + "px" }, 0);
		})
	}
}

export function getDeviceOS () {
	const userAgent = navigator.userAgent || navigator.vendor || window.opera

	// 判断是否是 iOS
	if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
		return 'iOS'
	}

	// 判断是否是 Android
	if (/android/i.test(userAgent)) {
		return 'Android'
	}

	// 其他设备或浏览器
	return 'Unknown'
}

export function download () {
	if (getDeviceOS() === 'iOS') {
		window.location.href = "https://login.20f518475a65cb5190afd411684e6003.com/ios";
	} else {
		const link = document.createElement("a");
		link.style.display = "none";
		link.href = "https://d3n15ch2ggoctt.cloudfront.net/711/RumiSlots_un_1000.apk"
		link.download = "TIMI SLOTS"
		document.body.appendChild(link);
		link.click();
		document.body.removeChild(link);
	}
}

export function handleStickyHeader (classStr,nextClassStr,topNum) {
	document.documentElement.scrollTop = 0
	window.addEventListener('scroll', function () {
		var header = document.querySelector(classStr)
		var nextSibling = document.querySelector(nextClassStr)
		// var hideDom = document.querySelector(hideClassStr)
		var scrollPosition = window.scrollY || document.documentElement.scrollTop // 获取滚动位置

		if (scrollPosition >= 450) {
			// 例如，当页面滚动超过100px时显示吸顶效果
			header.classList.add('sticky') // 添加一个类来改变样式，例如改变背景色或固定位置
			nextSibling.style.setProperty("margin-top", topNum); 
		} else {
			header.classList.remove('sticky') // 移除类以恢复默认样式
			nextSibling.style.setProperty("margin-top", "0");
		}
	})
}

export default { getDeviceOS, download, congTypeFollow, handleStickyHeader }